// import React, { useEffect, useRef, useState } from 'react';
// import Chart from 'chart.js/auto';
// import { Dropdown } from 'react-bootstrap';

// const companyOptions = [
//     { value: 'company-a', label: 'Company A' },
//     { value: 'company-b', label: 'Company B' },
//     { value: 'company-c', label: 'Company C' },
// ];

// const yearOptions = [
//     { value: '2022', label: '2022' },
//     { value: '2023', label: '2023' },
//     { value: '2024', label: '2024' },
// ];

// const RelationshipTypeChart = (props) => {
//     const chartRef = useRef(null);
//     const [selectedCompany, setSelectedCompany] = useState(companyOptions[0]);
//     const [selectedYear, setSelectedYear] = useState(yearOptions[0]);

//     useEffect(() => {
//         const chartInstance = new Chart(chartRef.current, {
//             type: 'doughnut',
//             data: {
//                 labels: ['Headquarter', 'Business Unit', 'Branch Office', 'Storage Location'],
//                 datasets: [
//                     {
//                         data: [42, 25, 20, 13],
//                         backgroundColor: ['rgba(58, 201, 119, 1)', 'rgba(255, 94, 94, 1)', 'rgba(255, 159, 0, 1)', 'rgba(52, 58, 64, 1)'],
//                         hoverBackgroundColor: ['rgba(58, 201, 119, 1)', 'rgba(255, 94, 94, 1)', 'rgba(255, 159, 0, 1)', 'rgba(52, 58, 64, 1)'],
//                     },
//                 ],
//             },
//             options: {
//                 cutout: '70%',
//                 plugins: {
//                     legend: {
//                         display: false,
//                     },
//                     tooltip: {
//                         callbacks: {
//                             label: function (tooltipItem) {
//                                 return `${tooltipItem.label}: ${tooltipItem.raw}%`;
//                             },
//                         },
//                     },
//                 },
//             },
//         });

//         return () => {
//             chartInstance.destroy();
//         };
//     }, []);

//     const handleCompanySelect = (company) => {
//         setSelectedCompany(company);
//         // Add logic to update the chart based on the selected company
//     };

//     const handleYearSelect = (year) => {
//         setSelectedYear(year);
//         // Add logic to update the chart based on the selected year
//     };

//     return (
//         <div className='barchart-container relation-type-chart-container'>
//             <h6 className='pt-2'>
//                 {props.moduleName}
//                 {/* Relationship Type */}
//             </h6>
//             <div className='relation-type-chart-btns'>
//                 <Dropdown>
//                     <Dropdown.Toggle id="dropdown-company">
//                         {selectedCompany.label}
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                         {companyOptions.map(option => (
//                             <Dropdown.Item
//                                 key={option.value}
//                                 onClick={() => handleCompanySelect(option)}
//                                 active={selectedCompany.value === option.value}
//                             >
//                                 {option.label}
//                             </Dropdown.Item>
//                         ))}
//                     </Dropdown.Menu>
//                 </Dropdown>
//                 <Dropdown>
//                     <Dropdown.Toggle id="dropdown-year">
//                         {selectedYear.label}
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                         {yearOptions.map(option => (
//                             <Dropdown.Item
//                                 key={option.value}
//                                 onClick={() => handleYearSelect(option)}
//                                 active={selectedYear.value === option.value}
//                             >
//                                 {option.label}
//                             </Dropdown.Item>
//                         ))}
//                     </Dropdown.Menu>
//                 </Dropdown>
//             </div>
//             <div className='customer-status-chart'>
//                 <div style={{ width: '50%' }}>
//                     <canvas ref={chartRef} />
//                 </div>
//                 <div style={{ width: '45%', marginLeft: '16px' }} className='relationship-indicators-container'>
//                     <div style={{ marginBottom: '8px' }} className='relationship-indicators-names'>
//                         <span style={{ backgroundColor: '#00A878', width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> Headquarter
//                     </div>
//                     <div style={{ marginBottom: '8px' }} className='relationship-indicators-names'>
//                         <span style={{ backgroundColor: '#F75C4C', width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> Business Unit
//                     </div>
//                     <div style={{ marginBottom: '8px' }} className='relationship-indicators-names'>
//                         <span style={{ backgroundColor: '#F2A20C', width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> Branch Office
//                     </div>
//                     <div style={{ marginBottom: '8px' }} className='relationship-indicators-names'>
//                         <span style={{ backgroundColor: '#4A4A4A', width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> Storage Location
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RelationshipTypeChart;


import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Dropdown, Carousel } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadCompanyDropdownData, loadComplaintEscalationPriorityStatusData, loadCustomerDashboardRelationshipTypeChartData, loadReportingToDropdownData, loadSLADashboardAssignedScoreData } from '../../redux/action';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import Exporting from 'highcharts/modules/exporting';
import * as ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell } from "docx";
import { saveAs } from "file-saver";

// Example options for other dropdowns (static)
const assignedToOptions = [
    { value: 'assignedTo1', label: 'assignedTo1' },
    { value: 'assignedTo2', label: 'assignedTo2' },
    { value: 'assignedTo3', label: 'assignedTo3' },
];

const monthOptions = [
    { value: 'january', label: 'January' },
    { value: 'february', label: 'February' },
    { value: 'march', label: 'March' },
    // Add other months...
];

const approverOptions = [
    { value: 'approver-a', label: 'Approver A' },
    { value: 'approver-b', label: 'Approver B' },
    { value: 'approver-c', label: 'Approver C' },
];

const RelationshipTypeChart = React.forwardRef(({
    moduleName = 'Relationship Type',
    labels = [],
    colors = [],
    // data = [],
    showMonth = false,
    showAssignedTo = false,
    showYear = false,
    showCompany = false,
    showApprover = false
}, ref) => {
    let dispatch = useDispatch();
    const location = useLocation();
    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { complaintEscalationPriorityStatusData } = useSelector((state) => state.data);
    const { getCustomerDashboardRelationShipTypeData } = useSelector((state) => state.data);
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { getSlaDashboardAssignedScoreData } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;
    const currentYear = new Date().getFullYear();

    const [selectedCompany, setSelectedCompany] = useState({ value: storedCompanyId, label: storedCompanyName });
    const [selectedAssignedTo, setSelectedAssignedTo] = useState({ value: "", label: "" });
    const [selectedYear, setSelectedYear] = useState({ value: currentYear, label: currentYear }); // Default to the first year in the range
    const [selectedMonth, setSelectedMonth] = useState(monthOptions[0]);
    const [selectedApprover, setSelectedApprover] = useState(approverOptions[0]);
    const [data, setData] = useState([]);
    const [relationshipLabels, setRelationshipLabels] = useState([]);  // Renamed from labels to relationshipLabels
    const [complaintLabels, setComplaintLabels] = useState([]);
    const [assignedScoreLabels, setAssignedScoreLabels] = useState({});

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
        dispatch(loadReportingToDropdownData());
    }, [dispatch]);

    useEffect(() => {
        if (selectedCompany && selectedYear) {
            // dispatch(loadCustomerDashboardRelationshipTypeChartData(selectedCompany.value, selectedYear.value));
            // Ensure the pathname is correct
            if (location.pathname === '/dashboard' || location.pathname === '/') {
                dispatch(loadCustomerDashboardRelationshipTypeChartData(selectedCompany.value, selectedYear.value));
            } else if (location.pathname === '/complaintDashboard') {
                dispatch(loadComplaintEscalationPriorityStatusData(selectedCompany.value, selectedYear.value));
            } else if (location.pathname === '/slaDashboard') {
                dispatch(loadSLADashboardAssignedScoreData(selectedCompany.value, selectedAssignedTo.value, selectedYear.value));
            }
        }
    }, [selectedCompany, selectedYear, selectedAssignedTo, location.pathname, dispatch]);

    // useEffect(() => {
    //     if (selectedCompany && selectedYear) {
    //         if (location.pathname === '/slaDashboard') {
    //             // Dispatch action with selectedOption (including companyId and year)
    //             dispatch(loadSLADashboardAssignedScoreData(selectedCompany.value, selectedAssignedTo.value, selectedYear.value));
    //         }
    //     }
    // }, [selectedCompany, selectedYear, selectedAssignedTo, location.pathname, dispatch]);

    // Handle dynamic data for relationship types
    useEffect(() => {
        if (getCustomerDashboardRelationShipTypeData) {
            const relationshipTypes = getCustomerDashboardRelationShipTypeData;
            const labels = Object.keys(relationshipTypes);
            const data = Object.values(relationshipTypes);
            setRelationshipLabels(labels);  // Set relationshipLabels
            setDataState(data);
        }
    }, [getCustomerDashboardRelationShipTypeData]);

    useEffect(() => {
        if (getSlaDashboardAssignedScoreData) {
            const assignedScores = getSlaDashboardAssignedScoreData;
            const labels = Object.keys(assignedScores);
            const data = Object.values(assignedScores);
            setAssignedScoreLabels(labels);  // Set relationshipLabels
            setDataState(data);
        }
    }, [getSlaDashboardAssignedScoreData]);

    // Handle dynamic data for complaint escalation priority status
    useEffect(() => {
        if (complaintEscalationPriorityStatusData) {
            const transformedData = [
                complaintEscalationPriorityStatusData['High'] || 0,
                complaintEscalationPriorityStatusData['Medium'] || 0,
                complaintEscalationPriorityStatusData['Low'] || 0
            ];
            setComplaintLabels(['High', 'Medium', 'Low']);  // Set complaintLabels
            setDataState(transformedData);
        }
    }, [complaintEscalationPriorityStatusData]);

    // Function to generate an array of years from 2020 to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear();  // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
        // Reset chart data when company changes
        setRelationshipLabels([]);
        setDataState([]);
    };

    const handleAssignedToSelect = (assignedTo) => {
        setSelectedAssignedTo(assignedTo);
        // Add logic to update the chart based on the selected assignedTo
    };

    const handleYearSelect = (year) => {
        setSelectedYear(year);
        // Reset chart data when company changes
        setRelationshipLabels([]);
        setDataState([]);
    };

    const handleMonthSelect = (month) => {
        setSelectedMonth(month);
        // Add logic to update the chart based on the selected month
    };

    const handleApproverSelect = (approver) => {
        setSelectedApprover(approver);
        // Add logic to update the chart based on the selected approver
    };
    const [dataState, setDataState] = useState([]);

    const chartOptions = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent', // Remove background color
            height: '100%' // Set the chart height (adjust as needed)
        },
        title: {
            text: null, // Remove chart title
        },
        subtitle: {
            text: null, // Remove subtitle
        },
        credits: {
            enabled: false // Disable Highcharts credits
        },
        plotOptions: {
            pie: {
                innerSize: '70%',
                dataLabels: {
                    enabled: false, // Disable data labels inside the chart
                },
                showInLegend: false, // Disable the legend
            },
        },
        colors: colors,
        // series: [{
        //     name: 'Percentage',
        //     data: labels.map((label, index) => [label, data[index]]),
        // }],
        // series: [{
        //     name: 'Percentage',
        //     data: labels.map((label, index) => {
        //         return [label, data[index] || 0]; // Ensure data matches the labels
        //     }),
        // }],
        series: [{
            name: 'Percentage',
            // data: (location.pathname === '/dashboard' ? relationshipLabels : complaintLabels).map((label, index) => {
            //     return [label, dataState[index] || 0];
            // }),
            data: (() => {
                let labels = [];
                if (location.pathname === '/dashboard' || location.pathname === '/') {
                    labels = Array.isArray(relationshipLabels) ? relationshipLabels : [];
                } else if (location.pathname === '/complaintDashboard') {
                    labels = Array.isArray(complaintLabels) ? complaintLabels : [];
                } else if (location.pathname === '/slaDashboard') {
                    labels = Array.isArray(assignedScoreLabels) ? assignedScoreLabels : [];
                }

                // Now that we are sure labels is an array, we can safely use map
                return labels.map((label, index) => {
                    return [label, dataState[index] || 0]; // Ensure data matches the labels
                });
            })(),
        }],
    };

    const chartInstance = useRef(null); // Define chartInstance reference

    useImperativeHandle(ref, () => ({
        handleDownloadImage: () => {
            const chartContainer = document.querySelector(".highcharts-container");
            if (!chartContainer) {
                console.log("Chart container is not available");
                return;
            }

            let labels = [];
            let data = [];

            // Load data based on the current route
            if (location.pathname === "/complaintDashboard") {
                labels = Object.keys(complaintEscalationPriorityStatusData);
                data = Object.values(complaintEscalationPriorityStatusData);
            } else if (location.pathname === "/dashboard" || location.pathname === "/") {
                labels = Object.keys(getCustomerDashboardRelationShipTypeData);
                data = Object.values(getCustomerDashboardRelationShipTypeData);
            } else if (location.pathname === "/slaDashboard") {
                labels = Object.keys(getSlaDashboardAssignedScoreData);
                data = Object.values(getSlaDashboardAssignedScoreData);
            }

            if (!labels.length || !data.length) {
                console.log("No data or labels to export");
                return;
            }

            const total = data.reduce((acc, value) => acc + value, 0);

            const tableData = labels.map((label, index) => ({
                Label: label,
                Value: data[index] || 0,
            }));

            const printableContent = document.createElement("div");
            printableContent.style.display = "flex";
            printableContent.style.flexDirection = "column";
            printableContent.style.alignItems = "center";
            document.body.appendChild(printableContent);

            // Clone chart container and add to printable content
            const chartClone = chartContainer.cloneNode(true);
            chartClone.style.margin = "20px auto";
            printableContent.appendChild(chartClone);

            // Create table and add to printable content
            const table = document.createElement("table");
            table.style.width = "100%";
            table.style.borderCollapse = "collapse";
            table.style.marginTop = "20px";
            table.innerHTML = `
                <tbody>
                    ${tableData.map(
                (row) =>
                    `<tr>
                                <td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${row.Label}</td>
                                <td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${row.Value}</td>
                            </tr>`
            ).join("")}
                </tbody>
                <tfoot>
                    <tr>
                        <th style="border: 1px solid #ccc; padding: 8px; text-align: center;">Total</th>
                        <th style="border: 1px solid #ccc; padding: 8px; text-align: center;">${total}</th>
                    </tr>
                </tfoot>
            `;
            printableContent.appendChild(table);

            // Use html2canvas to capture the chart and table
            html2canvas(printableContent, { scale: 2 })
                .then((canvas) => {
                    const imageData = canvas.toDataURL("image/png");
                    const link = document.createElement("a");
                    link.href = imageData;
                    link.download = `${location.pathname === "/complaintDashboard"
                        ? "Complaint_Status"
                        : location.pathname === "/slaDashboard"
                            ? "SLA_Status"
                            : "Relationship_Type_Status"
                        }_Chart_With_Data.png`;
                    link.click();

                    document.body.removeChild(printableContent);
                })
                .catch((error) => {
                    console.error("Error capturing chart and table:", error);
                });
        },
        handleDownloadExcel: () => {
            let labels = [];
            let data = [];

            // Load data based on the current route
            if (location.pathname === "/complaintDashboard") {
                labels = Object.keys(complaintEscalationPriorityStatusData);
                data = Object.values(complaintEscalationPriorityStatusData);
            } else if (location.pathname === "/dashboard" || location.pathname === "/") {
                labels = Object.keys(getCustomerDashboardRelationShipTypeData);
                data = Object.values(getCustomerDashboardRelationShipTypeData);
            } else if (location.pathname === "/slaDashboard") {
                labels = Object.keys(getSlaDashboardAssignedScoreData);
                data = Object.values(getSlaDashboardAssignedScoreData);
            }

            if (!labels.length || !data.length) {
                console.log("No data to export");
                return;
            }

            const total = data.reduce((acc, value) => acc + value, 0);

            // Create a new workbook and a worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Chart Data');

            // Set headers for the table
            worksheet.addRow(['Label', 'Value']);

            // Add data rows
            labels.forEach((label, index) => {
                worksheet.addRow([label, data[index] || 0]);
            });

            // Add the total row
            worksheet.addRow(['Total', total]);

            // Apply styling (optional)
            worksheet.getRow(1).font = { bold: true };  // Make the header row bold
            worksheet.columns = [
                { width: 30 }, // Label column width
                { width: 20 }, // Value column width
            ];

            // Capture the chart as an image
            const chartContainer = document.querySelector(".highcharts-container");
            if (!chartContainer) {
                console.log("Chart container not found");
                return;
            }

            html2canvas(chartContainer, { scale: 2 }).then((canvas) => {
                const imageData = canvas.toDataURL("image/png");

                // Add the chart image to the Excel file
                const imageId = workbook.addImage({
                    base64: imageData,
                    extension: 'png',
                });

                worksheet.addImage(imageId, 'B1:F20'); // Insert image at a specific location

                // Write the Excel file and trigger download
                workbook.xlsx.writeBuffer().then((buffer) => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = `${location.pathname === "/complaintDashboard"
                        ? "Complaint_Status"
                        : location.pathname === "/slaDashboard"
                            ? "SLA_Status"
                            : "Relationship_Type_Status"
                        }_Chart_Data_with_Image.xlsx`;
                    link.click();
                }).catch((error) => {
                    console.error("Error generating Excel file:", error);
                });
            }).catch((error) => {
                console.error("Error capturing chart:", error);
            });
        },
        handleDownloadPDF: () => {
            const chartContainer = document.querySelector(".highcharts-container");
            if (!chartContainer) {
                console.log("Chart container is not available");
                return;
            }

            let labels = [];
            let data = [];

            // Load data based on the current route
            if (location.pathname === "/complaintDashboard") {
                labels = Object.keys(complaintEscalationPriorityStatusData);
                data = Object.values(complaintEscalationPriorityStatusData);
            } else if (location.pathname === "/dashboard" || location.pathname === "/") {
                labels = Object.keys(getCustomerDashboardRelationShipTypeData);
                data = Object.values(getCustomerDashboardRelationShipTypeData);
            } else if (location.pathname === "/slaDashboard") {
                labels = Object.keys(getSlaDashboardAssignedScoreData);
                data = Object.values(getSlaDashboardAssignedScoreData);
            }

            if (!labels.length || !data.length) {
                console.log("No data or labels to export");
                return;
            }

            const total = data.reduce((acc, value) => acc + value, 0);

            const tableData = labels.map((label, index) => ({
                Label: label,
                Value: data[index] || 0,
            }));

            // Use html2canvas to capture the chart content (container)
            html2canvas(chartContainer, { scale: 2 })
                .then((canvas) => {
                    const img = new Image();
                    img.src = canvas.toDataURL("image/png");

                    img.onload = () => {
                        // Create a circular canvas to crop the image
                        const circularCanvas = document.createElement('canvas');
                        const ctx = circularCanvas.getContext('2d');
                        const size = Math.min(img.width, img.height);  // Ensure it’s a square

                        circularCanvas.width = size;
                        circularCanvas.height = size;

                        // Draw the image in a circular shape
                        ctx.beginPath();
                        ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, false); // Circular path
                        ctx.closePath();
                        ctx.clip();
                        ctx.drawImage(img, (size - img.width) / 2, (size - img.height) / 2);

                        // Generate the PDF with jsPDF
                        const doc = new jsPDF();

                        // Add the circular chart image to the PDF
                        doc.addImage(circularCanvas.toDataURL(), 'PNG', 15, 30, 180, 180);

                        // Add table below the chart
                        doc.autoTable({
                            head: [['Label', 'Value']],
                            body: tableData.map(row => [row.Label, row.Value]),
                            startY: 220,  // Adjust position to place the table below the chart
                            theme: 'grid',
                        });

                        // Save the PDF
                        doc.save(`${location.pathname === "/complaintDashboard"
                            ? "Complaint_Status"
                            : location.pathname === "/slaDashboard"
                                ? "SLA_Status"
                                : "Relationship_Type_Status"
                            }_Chart_With_Data.pdf`);
                    };
                })
                .catch((error) => {
                    console.error("Error capturing chart:", error);
                });
        },
        handleDownloadWord: () => {
            const chartContainer = document.querySelector(".highcharts-container");
            if (!chartContainer) {
                console.log("Chart container is not available");
                return;
            }

            let labels = [];
            let data = [];

            // Load data based on the current route
            if (location.pathname === "/complaintDashboard") {
                labels = Object.keys(complaintEscalationPriorityStatusData);
                data = Object.values(complaintEscalationPriorityStatusData);
            } else if (location.pathname === "/dashboard" || location.pathname === "/") {
                labels = Object.keys(getCustomerDashboardRelationShipTypeData);
                data = Object.values(getCustomerDashboardRelationShipTypeData);
            } else if (location.pathname === "/slaDashboard") {
                labels = Object.keys(getSlaDashboardAssignedScoreData);
                data = Object.values(getSlaDashboardAssignedScoreData);
            }

            if (!labels.length || !data.length) {
                console.log("No data or labels to export");
                return;
            }

            const total = data.reduce((acc, value) => acc + value, 0);

            const tableData = labels.map((label, index) => ({
                Label: label,
                Value: data[index] || 0,
            }));

            // Use html2canvas to capture the chart content (container)
            html2canvas(chartContainer, { scale: 2 })
                .then((canvas) => {
                    const chartBase64 = canvas.toDataURL("image/png");

                    // Prepare the HTML content for the Word document
                    const content = `
                        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
                        <head><meta charset="utf-8"><title>Chart Data</title></head>
                        <body>
                            <h1>Chart Data</h1>
                            <img src="${chartBase64}" alt="Chart" style="max-width: 100%; height: auto;"/>
                            <table border="1" style="border-collapse: collapse; margin-top: 20px; width: 100%;">
                                <thead>
                                    <tr>
                                        <th>Label</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${tableData.map((row) => `<tr><td>${row.Label}</td><td>${row.Value}</td></tr>`).join('')}
                                    <tr><td>Total</td><td>${total}</td></tr>
                                </tbody>
                            </table>
                        </body>
                        </html>
                    `;

                    // Create a Blob and download the Word document
                    const blob = new Blob([content], { type: 'application/msword' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = `${location.pathname === "/complaintDashboard"
                        ? "Complaint_Status"
                        : location.pathname === "/slaDashboard"
                            ? "SLA_Status"
                            : "Relationship_Type_Status"
                        }_Chart_Data.doc`;
                    link.click();
                })
                .catch((error) => {
                    console.error("Error capturing chart:", error);
                });
        },
        handlePrint: () => {
            const chartContainer = document.querySelector(".highcharts-container");
            if (!chartContainer) {
                console.log("Chart container is not available");
                return;
            }

            let labels = [];
            let data = [];

            // Load data based on the current route
            if (location.pathname === "/complaintDashboard") {
                labels = Object.keys(complaintEscalationPriorityStatusData);
                data = Object.values(complaintEscalationPriorityStatusData);
            } else if (location.pathname === "/dashboard" || location.pathname === "/") {
                labels = Object.keys(getCustomerDashboardRelationShipTypeData);
                data = Object.values(getCustomerDashboardRelationShipTypeData);
            } else if (location.pathname === "/slaDashboard") {
                labels = Object.keys(getSlaDashboardAssignedScoreData);
                data = Object.values(getSlaDashboardAssignedScoreData);
            }

            if (!labels.length || !data.length) {
                console.log("No data or labels to print");
                return;
            }

            const total = data.reduce((acc, value) => acc + value, 0);

            const tableData = labels.map((label, index) => ({
                Label: label,
                Value: data[index] || 0,
            }));

            // Use html2canvas to capture the chart content (container)
            html2canvas(chartContainer, { scale: 2 })
                .then((canvas) => {
                    const chartBase64 = canvas.toDataURL("image/png");

                    // Prepare the HTML content for the print preview
                    const content = `
                        <html>
                        <head>
                            <style>
                                body {
                                    font-family: Arial, sans-serif;
                                    margin: 20px;
                                }
                                h1 {
                                    text-align: center;
                                }
                                table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    margin-top: 20px;
                                }
                                table, th, td {
                                    border: 1px solid black;
                                }
                                th, td {
                                    padding: 8px;
                                    text-align: left;
                                }
                                img {
                                    display: block;
                                    margin: 0 auto;
                                    max-width: 100%;
                                    height: auto;
                                }
                            </style>
                        </head>
                        <body>
                            <h1>Chart Data</h1>
                            <img src="${chartBase64}" alt="Chart"/>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Label</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${tableData.map((row) => `<tr><td>${row.Label}</td><td>${row.Value}</td></tr>`).join('')}
                                    <tr><td>Total</td><td>${total}</td></tr>
                                </tbody>
                            </table>
                        </body>
                        </html>
                    `;

                    // Create a new window and write the content
                    const printWindow = window.open('', '_blank', 'width=800,height=600');

                    if (printWindow) {
                        printWindow.document.write(content);
                        printWindow.document.close();

                        // Wait for the content to load, then trigger print
                        printWindow.onload = () => {
                            printWindow.print();
                            printWindow.close();
                        };
                    } else {
                        console.log("Popup blocked, please allow popups for this site.");
                    }
                })
                .catch((error) => {
                    console.error("Error capturing chart for print:", error);
                });
        },
    }));

    return (
        <div className='barchart-container relation-type-chart-container'>
            <div className='relationship-type-chart-header-div'>
                <h6 className='pt-2'>{moduleName}</h6>
                <div className='relation-type-chart-btns pt-2'>

                    {showCompany && (
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-company">
                                {selectedCompany?.label ? selectedCompany?.label : 'Select Company'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {getCompanyDropdown?.map(option => (
                                    <Dropdown.Item
                                        key={option.value}
                                        onClick={() => handleCompanySelect(option)}
                                        active={selectedCompany?.value === option.value}
                                    >
                                        {option.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                    {showAssignedTo && (
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-assigned-to">
                                {selectedAssignedTo?.label ? selectedAssignedTo?.label : "Assigned To"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {reportingToDropdown.map(option => (
                                    <Dropdown.Item
                                        key={option.value}
                                        onClick={() => handleAssignedToSelect(option)}
                                        active={selectedAssignedTo?.value === option.value}
                                    >
                                        {option.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                    {showYear && (
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-year">
                                {selectedYear.label}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {generateYearRange(2022).map(option => (
                                    <Dropdown.Item
                                        key={option.value}
                                        onClick={() => handleYearSelect(option)}
                                        active={selectedYear.value === option.value}
                                    >
                                        {option.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </div>
            </div>
            <div className='relation-type-chart-btns pt-2'>
                {showMonth && (
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-month">
                            {selectedMonth.label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {monthOptions.map(option => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleMonthSelect(option)}
                                    active={selectedMonth.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}

                {showApprover && (
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-approver">
                            {selectedApprover.label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {approverOptions.map(option => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleApproverSelect(option)}
                                    active={selectedApprover.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
            <div className='customer-status-chart d-flex'>
                <div style={{ width: '60%' }} className='highchart-container'>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions}
                        ref={chartInstance}
                    />
                </div>
                <div>
                    <div className='carousel-container'>
                        <Carousel>
                            {labels.map((label, index) => (
                                <Carousel.Item key={label}>
                                    <div style={{ marginBottom: '8px' }} className='relationship-indicators-names'>
                                        <span style={{ backgroundColor: colors[index], width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> {label}
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </div>

                    <div className='relationship-indicators-names carousel-none-div'>
                        {labels.map((label, index) => (
                            <div key={label} style={{ marginBottom: '8px' }}>
                                <span style={{ backgroundColor: colors[index], width: '12px', height: '12px', display: 'inline-block', borderRadius: '50%' }}></span> {label}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default RelationshipTypeChart;





